import React, { useState, useCallback, useEffect } from 'react';
import {
  Box,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { DateTimeField } from '../../../../../Components/Field';
import { StepProps } from './types';
import { StepButtonBar } from './StepButtonBar';
import OtherRequirementInfo from './OtherRequirementInfo';

interface Step7EffectiveToSendoutTimeProps extends StepProps {
  otherRequirementInfo: any;
  setOtherRequirementInfo: (any) => void;
}

const Step7EffectiveToSendoutTime: React.FC<Step7EffectiveToSendoutTimeProps> = ({
  currentStepName,
  onNext,
  onBack,
  onCancel,
  currentData,
  isFirstStep,
  otherRequirementInfo,
  setOtherRequirementInfo,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const [effectiveToSendoutTime, setEffectiveToSendoutTime] = useState<Date | undefined>(
    currentData.effectiveToSendoutTime ? new Date(currentData.effectiveToSendoutTime) : undefined
  );

  useEffect(() => {
    if (currentData.effectiveToSendoutTime) {
      setEffectiveToSendoutTime(new Date(currentData.effectiveToSendoutTime));
    }
  }, [currentData.effectiveToSendoutTime]);

  const handleEffectiveToSendoutTimeChange = useCallback((val: any) => {
    if (val && typeof val === 'object' && 'value' in val) {
      setEffectiveToSendoutTime(val.value);
    } else if (val === undefined || val === null) {
      setEffectiveToSendoutTime(undefined);
    }
  }, []);

  const handleNext = () => {
    onNext({
      effectiveToSendoutTime: effectiveToSendoutTime || undefined,
    });
  };

  const isValid = true; // Field is optional

  return (
    <Box style={{ width: '100%' }}>
      <Box
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <Box
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <DateTimeField
              name="effective-to-sendout-time"
              placeholder={formatMessage({ id: 'law-portal.manage.requirements.effective-to-sendout-time', defaultMessage: 'Effective To Sendout Time' })}
              errorTexts={[]}
              initialState={effectiveToSendoutTime ? { value: effectiveToSendoutTime } : undefined}
              onChange={handleEffectiveToSendoutTimeChange}
            />
          </Box>
        </Box>

        <OtherRequirementInfo otherRequirementStepInfo={otherRequirementInfo} currentStepName={currentStepName} onUpdate={setOtherRequirementInfo} />
      </Box>

      <StepButtonBar
        onCancel={onCancel}
        onBack={onBack}
        onNext={handleNext}
        nextLabel="form.next"
        nextDisabled={!isValid}
        formatMessage={formatMessage}
        showBack={true}
      />
    </Box>
  );
};

export default Step7EffectiveToSendoutTime;
